import './datatablesStyles.css';

export const getDataTableStyles = (isDark) => ({
  tableWrapper: {
    style: {
      borderRadius: '0',
    },
  },
  responsiveWrapper: {
    style: {
      borderRadius: '0',
      overflow: 'visible',
    },
  },
  table: {
    style: {
      backgroundColor: isDark ? '#151d2c' : '#fcfcfc', // gray-870 (dark) / surface (light)
      borderRadius: '0',
    },
  },
  headRow: {
    style: {
      // flat surface: gray-870 (dark) / off-white surface (light)
      backgroundColor: isDark ? '#151d2c' : '#fcfcfc',
      color: isDark ? '#E5E7EB' : '#0F172A', // slate-900
      fontWeight: 600,
      fontSize: '14px',
      // light: slate-200 (10% on slate-900 visual). dark: gray-700
      borderBottom: `1px solid ${isDark ? '#374151' : '#E2E8F0'}`,
    },
    className: 'data-table-header',
  },
  headCells: {
    style: {
      paddingLeft: '16px',
      paddingRight: '16px',
      textAlign: 'left',
    },
    className: 'data-table-header',
  },
  rows: {
    style: (row, index, rows = []) => ({
      minHeight: '56px',
      backgroundColor: isDark ? '#151d2c' : '#fcfcfc', // gray-870 (dark) / surface (light)
      color: isDark ? '#E5E7EB' : '#374151', // gray-700 (matches global body)
      fontSize: '14px',
      borderBottom: index === rows.length - 1 ? 'none' : `1px solid ${isDark ? '#374151' : '#E2E8F0'}`,
    }),
    className: 'data-table-text',
  },
  selectableRowsHighlight: false,
  cells: {
    style: {
      paddingLeft: '16px',
      paddingRight: '16px',
      textAlign: 'left',
    },
    className: 'data-table-text',
  },
  pagination: {
    style: (page, rows) => ({
      borderTop: page.rowCount > 0 ? `1px solid ${isDark ? '#374151' : '#E5E7EB'}` : 'none',
      padding: '16px',
      justifyContent: 'center',
    }),
    className: 'data-table-pagination',
  },
});

// Backward-compatible default export using current document theme if available
export const customStyles = getDataTableStyles(typeof document !== 'undefined' && document.documentElement.classList.contains('dark'));
